import * as React from 'react';
import classNames from 'classnames';
import {getVariantClass} from '../../utilities';

const LABEL_TYPES = {
  base: 'marketing-label',
  checkBox: 'marketing-checkbox-label',
  radio: 'marketing-radio-label',
};

const LABEL_VARIANTS = {
  hidden: `${getVariantClass(LABEL_TYPES.base, 'hidden')} visuallyhidden`,
  inField: getVariantClass(LABEL_TYPES.base, 'in-field'),
  floating: getVariantClass(LABEL_TYPES.base, 'floating'),
};

export type LabelMode = 'radio' | 'checkbox';

type LabelElementProps = JSX.IntrinsicElements['label'];

export interface LabelProps extends LabelElementProps {
  text?: string;
  mode?: LabelMode;
  hidden?: boolean;
  inField?: boolean;
  floating?: boolean;
}

export function Label({
  text = '',
  mode = '',
  hidden = false,
  inField = false,
  floating = false,
  children,
  ...restProps
}: LabelProps) {
  const baseClass = LABEL_TYPES[mode] || LABEL_TYPES.base;

  const labelProps = {
    className: classNames(baseClass, {
      [LABEL_VARIANTS.hidden]: hidden,
      [LABEL_VARIANTS.inField]: inField,
      [LABEL_VARIANTS.floating]: floating,
    }),
    ...restProps,
  };

  return React.createElement(
    'label',
    labelProps,
    text || children,
  );
}

export default Label;
